import { render, staticRenderFns } from "./SimpleContactInput.vue?vue&type=template&id=2e1386ca&scoped=true"
import script from "./SimpleContactInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleContactInput.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1386ca",
  null
  
)

export default component.exports